// extracted by mini-css-extract-plugin
export default {"addressSection":"IY-z","disabled":"JY-z","sectionButtons":"KY-z","logo":"LY-z"};